import { Button, ButtonProps } from "antd";

import React, { ReactNode } from "react";

interface IIconButtonProps extends ButtonProps {
    icon: ReactNode;
    position?: "left" | "right";
    children?: ReactNode;
}

/**
 * IconButton component renders a button with an optional icon.
 * The icon can be positioned either to the left or right of the children.
 *
 * @component
 * @param {React.ReactNode} icon - The icon to be displayed
 * @param {string} position - The position of the icon ('left' or 'right')
 * @param {React.ReactNode} children - The content to be displayed inside the button
 * @returns {JSX.Element} The rendered button component
 */
const IconButton: React.FC<IIconButtonProps> = ({ icon, position, children, style, ...props }) => (
    <Button {...props} style={{ ...style }}>
        {position !== "right" && icon}
        {children}
        {position === "right" && icon}
    </Button>
);

export default IconButton;
